// —————— POPOLAMENTO GRID TESSUTI ——————
document.addEventListener("DOMContentLoaded", function () {
    var tessutiData = {
        tessuti: [
            {
                categoria: "boucle",
                elementi: [
                    {
                        nome: "Bouclè Orbita - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Horby-031-menta.jpg?v=1717578337",
                        dettaglioUrl: "/pages/boucle-orbita",
                    },
                    {
                        nome: "Bouclè Nevada 300 - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Sierra-301.jpg?v=1717604191",
                        dettaglioUrl: "/pages/boucle-nevada-300",
                    },
                    {
                        nome: "Bouclè Nevada 100 - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Sierra-102.jpg?v=1717603599",
                        dettaglioUrl: "/pages/boucle-nevada-100",
                    },
                    {
                        nome: "Bouclè Nevada - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Sierra-014.jpg?v=1717602283",
                        dettaglioUrl: "/pages/boucle-nevada",
                    },
                ],
            },
            {
                categoria: "tessuti-naturali",
                elementi: [
                    {
                        nome: "Cotone Milano - Cat. L",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/cotone-milano.webp?v=1708449513",
                        dettaglioUrl: "/pages/cotone-milano-cat-smart",
                    },
                    {
                        nome: "Cotone Venus - Cat. MN",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Venus_col._11.jpg?v=1747230060",
                        dettaglioUrl: "/pages/cotone-venus",
                    },
                    {
                        nome: "Misto cotone lino Ranger - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Misto_cotone_lino.webp",
                        dettaglioUrl: "/pages/misto-cotone-lino-ranger-cat-mn",
                    },
                    {
                        nome: "Misto juta lino Sixties - Cat. Super",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Misto-juta-lino-Sixties-104.jpg?v=1748080576",
                        dettaglioUrl: "/pages/misto-juta-lino-sixties",
                    },
                ],
            },
            {
                categoria: "microfibra",
                elementi: [
                    {
                        nome: "Microfibra Jazz - Cat. Basic",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/microfibra-Jazz-737.jpg?v=1748079329",
                        dettaglioUrl: "/pages/microfibra-astrea-cat-basic",
                    },
                    {
                        nome: "Microfibra Blues - Cat. Smart",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Microfibra_Blues-306-SMART.png?v=1709919665",
                        dettaglioUrl: "/pages/microfibra-blues-cat-smart",
                    },
                ],
            },
            {
                categoria: "tessuti-misti",
                elementi: [
                    {
                        nome: "Misto cotone Gabrielle - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/misto-cotone-gabrielle.webp?v=1708450465",
                        dettaglioUrl: "/pages/misto-cotone-gabrielle-cat-extra",
                    },
                    {
                        nome: "Misto Cotone Chanel - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/misto-cotone-chanel.webp",
                        dettaglioUrl: "/pages/misto-cotone-chanel-cat-extra",
                    },
                    {
                        nome: "Tessuto Mercury - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/M107_col._19.jpg?v=1746867510",
                        dettaglioUrl: "/pages/tessuto-mercury",
                    },
                    {
                        nome: "Tessuto Nomade - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Nomad-218-tabacco.jpg?v=1717585738",
                        dettaglioUrl: "/pages/tessuto-nomade",
                    },
                    {
                        nome: "Tessuto Crespo - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/M195_col._02.jpg?v=1746954719",
                        dettaglioUrl: "/pages/tessuto-crespo",
                    },
                    {
                        nome: "Misto viscosa Axum - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/MIsto_viscosa_axum.webp?v=1708526528",
                        dettaglioUrl: "/pages/misto-viscosa-axum-cat-extra",
                    },
                    {
                        nome: "Tessuto Chakra - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/chakra_13.jpg?v=1747153098",
                        dettaglioUrl: "/pages/tessuto-chakra",
                    },
                    {
                        nome: "Misto viscosa James - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/MIsto_viscosa_james.webp",
                        dettaglioUrl: "/pages/misto-viscosa-james-cat-mn",
                    },
                    {
                        nome: "Misto viscosa cotone Bond - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/misto_viscosa_cotone_bond.webp",
                        dettaglioUrl: "/pages/misto-viscosa-bond-cat-mn",
                    },
                ],
            },
            {
                categoria: "green",
                elementi: [
                    {
                        nome: "Tessuto RPet Mumble - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/green_mumble.webp",
                        dettaglioUrl: "/pages/tessuto-rpet-mumble-cat-extra",
                    },
                ],
            },
            {
                categoria: "tessuti-idro",
                elementi: [
                    {
                        nome: "Tessuto Lyra - Cat. L",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/tessuti_idrorepellenti_lyra.webp",
                        dettaglioUrl: "/pages/tessuto-lyra-cat-l",
                    },
                    {
                        nome: "Tessuto Oviedo - Cat. Smart",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Oviedo_64.jpg?v=1746712579",
                        dettaglioUrl: "/pages/tessuto-oviedo",
                    },
                    {
                        nome: "Tessuto Dalton - Cat. Smart",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/tessuti_idrorepellenti_dalton.webp?v=1708526966",
                        dettaglioUrl: "/pages/tessuto-dalton-cat-smart",
                    },
                ],
            },
            {
                categoria: "velluto",
                elementi: [
                    {
                        nome: "Velluto Barkley - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/velluto_Barkley.webp?v=1708527252",
                        dettaglioUrl: "/pages/velluto-barkley-cat-extra",
                    },
                    {
                        nome: "Velluto Firenze - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/velluto_firenze.webp",
                        dettaglioUrl: "/pages/velluto-firenze-cat-extra",
                    },
                    {
                        nome: "Velluto Pegaso - Cat. Extra",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Azimut-401.jpg?v=1717573630",
                        dettaglioUrl: "https://sofable.com/pages/velluto-pegaso",
                    },
                ],
            },
            {
                categoria: "outdoor",
                elementi: [
                    {
                        nome: "Tessuto outdoor Maestrale - Cat. MN",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Maestrale_707.jpg?v=1747171706",
                        dettaglioUrl: "/pages/tessuto-outdoor-maestrale",
                    },
                    {
                        nome: "Tessuto outdoor Libeccio - Cat. MN",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Libeccio_800.jpg?v=1747173675",
                        dettaglioUrl: "/pages/tessuto-outdoor-libeccio",
                    },
                ],
            },
            {
                categoria: "pelle",
                elementi: [
                    {
                        nome: "Pelle Bronco - Cat. 600",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Pelle_Bronco_-_Cat._600_-_Grigio.jpg?v=1710003178",
                        dettaglioUrl: "/pages/pelle-bronco-cat-600",
                    },
                    {
                        nome: "Pelle Stone - Cat. 700",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Stone-Zaffiro.jpg?v=1746886495",
                        dettaglioUrl: "/pages/pelle-stone-cat-700",
                    },
                    {
                        nome: "Pelle Wild - Cat. 700",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Pelle_Wild.webp?v=1708527448",
                        dettaglioUrl: "/pages/pelle-wild-cat-700",
                    },
                    {
                        nome: "Pelle Old - Cat. 700",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/PELLE-OLD-RANCH.jpg?v=1747239032",
                        dettaglioUrl: "/pages/pelle-old-cat-700",
                    },
                    {
                        nome: "Pelle Oasis - Cat. 700",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Oasis_Sonora.jpg?v=1746723634",
                        dettaglioUrl: "/pages/pelle-oasis",
                    },
                    {
                        nome: "Pelle Kelly - Cat. 700",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Kelly-700-Canyon.jpg?v=1746718100",
                        dettaglioUrl: "/pages/pelle-kelly",
                    },
                    {
                        nome: "Pelle Camoscio - Cat. 800",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Camoscio_36.jpg?v=1747069618",
                        dettaglioUrl: "/pages/pelle-camoscio",
                    },
                    {
                        nome: "Pelle Crust patinata a mano - Cat. 950",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Pelle_Patinata.webp",
                        dettaglioUrl: "/pages/pelle-crust-patinata-cat-950",
                    },
                    {
                        nome: "Pelle Nabuk - Cat. 950",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Nabuk.webp",
                        dettaglioUrl: "/pages/pelle-nabuk-cat-950",
                    },
                ],
            },
            {
                categoria: "cuoio",
                elementi: [
                    {
                        nome: "Vero Cuoio Galuchat - Cat. 950",
                        immagineUrl:
                            "https://cdn.shopify.com/s/files/1/0799/0145/8771/files/Galuchat_Marrone.jpg?v=1747169536",
                        dettaglioUrl: "/pages/vero-cuoio-galuchat",
                    },
                ],
            },
        ]
    };

    var container = document.getElementById("container");
    tessutiData.tessuti.forEach(function (categoria) {
        categoria.elementi.forEach(function (tessuto) {
            var div = document.createElement("div");
            div.className = "mix " + categoria.categoria;
            div.innerHTML = `
          <div class="tessuto-item">
            <a href="${tessuto.dettaglioUrl}">
              <img src="${tessuto.immagineUrl}" alt="${tessuto.nome}">
            </a>
            <p>${tessuto.nome}</p>
          </div>`;
            container.appendChild(div);
        });
    });

    mixitup(container, {
        selectors: { target: ".mix" },
        animation: { duration: 300 },
    });
});

// —————— LIGHTBOX ——————
function openLightbox(imgElement) {
    var lightbox = document.querySelector(".lightbox");
    var lightboxImg = lightbox.querySelector("img");
    lightboxImg.src = imgElement.src;
    lightbox.style.display = "flex";
    lightbox.classList.add("active");
}
function closeLightbox() {
    document.querySelector(".lightbox").classList.remove("active");
}

//////////////////////////////////////////////  PAGINA PRODOTTO  //////////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", function () {
  const getSamplerEl = () => document.getElementById("campionario-materiali");
  const getSelectedColorEl = () => document.getElementById("selectedColor");
  const getHiddenAltInput = () => document.getElementById("HiddenImageAlt");

  const addToCartSelectors = [
    '.button.button--xl[is="custom-button"]',
    'button[name="add"]',
    'button[type="submit"][name="add"]',
    '.product-form__submit',
    'form[action*="/cart/add"] [type="submit"]'
  ].join(',');

  let coloreSelezionato = null;
  let materialeAttivo = null;
  let errorMsg = null;

  function ensureErrorMsg() {
    const samplerEl = getSamplerEl();
    if (!samplerEl) return;
    if (!errorMsg) {
      errorMsg = document.createElement("div");
      errorMsg.className = "campionario-error";
      errorMsg.style.cssText = "display:none; margin-top:2px; font-size:0.9rem; color:#d00;";
      errorMsg.textContent = "Seleziona un colore per continuare.";
      // Il messaggio va sotto l'header dell'accordion, così resta visibile anche a pannello chiuso.
      const header = samplerEl.querySelector(".campionario-accordion__header");
      if (header) header.insertAdjacentElement("afterend", errorMsg);
      else {
        const legend = samplerEl.querySelector("legend");
        if (legend) legend.insertAdjacentElement("afterend", errorMsg);
        else samplerEl.appendChild(errorMsg);
      }
    }
  }

  // --- Accordion campionario ---
  const getPanelEl = () => document.getElementById("campionario-panel");
  const getToggleEl = () => document.getElementById("campionario-toggle");
  const getSelectValueEl = () => document.getElementById("campionario-select-value");

  function setSelectValue(text) {
    const el = getSelectValueEl();
    if (el) el.textContent = text;
  }

  function openAccordion(scrollIfHidden) {
    const panel = getPanelEl();
    const toggle = getToggleEl();
    if (!panel) return;
    panel.classList.add("is-open");
    if (toggle) toggle.setAttribute("aria-expanded", "true");
    if (scrollIfHidden) {
      const samplerEl = getSamplerEl();
      if (samplerEl) {
        const r = samplerEl.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) {
          samplerEl.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    }
  }

  function scrollToSampler() {
    const samplerEl = getSamplerEl();
    if (!samplerEl) return;
    const r = samplerEl.getBoundingClientRect();
    if (r.top < 0 || r.bottom > window.innerHeight) {
      samplerEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function closeAccordion() {
    const panel = getPanelEl();
    const toggle = getToggleEl();
    if (!panel) return;
    panel.classList.remove("is-open");
    if (toggle) toggle.setAttribute("aria-expanded", "false");
  }

  function scrollToFirstSwatch() {
    let target = null;
    document.querySelectorAll(".contenitore-metaobject").forEach((c) => {
      if (!target && getComputedStyle(c).display !== "none") {
        target = c.querySelector("img") || c;
      }
    });
    if (!target) target = getPanelEl();
    if (target) target.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function bindAccordionToggle() {
    const toggle = getToggleEl();
    if (!toggle || toggle.dataset.bound === "1") return;
    toggle.dataset.bound = "1";
    toggle.addEventListener("click", function () {
      const panel = getPanelEl();
      if (!panel) return;
      if (panel.classList.contains("is-open")) {
        closeAccordion();
      } else {
        openAccordion(false);
        // apertura: porto il primo campione in vista con uno scroll morbido
        requestAnimationFrame(scrollToFirstSwatch);
      }
    });
  }

  function showError(shouldScroll = false) {
    ensureErrorMsg();
    const samplerEl = getSamplerEl();
    if (!samplerEl || !errorMsg) return;

    errorMsg.style.display = "block";
    errorMsg.setAttribute("role", "alert");

    const legend = samplerEl.querySelector("legend");
    if (legend) {
      legend.style.borderRadius = "10px";
      legend.style.marginRight = "0px";
      legend.style.padding = "4px";
      legend.style.outline = "";
    }
    if (shouldScroll) {
      samplerEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function hideError() {
    if (errorMsg) {
      errorMsg.style.display = "none";
      errorMsg.removeAttribute("role");
    }
    const samplerEl = getSamplerEl();
    const legend = samplerEl?.querySelector("legend");
    if (legend) {
      legend.style.borderRadius = "";
      legend.style.marginRight = "";
      legend.style.padding = "";
      legend.style.outline = "";
    }
  }

  function getVisibleContainer() {
    const all = document.querySelectorAll(".contenitore-metaobject");
    for (const c of all) {
      if (getComputedStyle(c).display !== "none") return c;
    }
    return null;
  }

  function mustBlockAddToCart() {
    const samplerEl = getSamplerEl();
    if (!samplerEl) return false;
    const currentContainer = getVisibleContainer();
    if (!currentContainer) return false;
    const swatches = currentContainer.querySelectorAll("img");
    const deveScegliere = swatches.length > 0;
    return deveScegliere && !coloreSelezionato;
  }

  const toKey = (s) => (s || "").trim().toLowerCase().replace(/\s+/g, "_");

  function getAvailableMaterialKeys() {
    return Array.from(document.querySelectorAll('.contenitore-metaobject[data-materiale]'))
      .map(el => el.getAttribute('data-materiale'))
      .filter(Boolean);
  }

  function getCurrentMaterialFromUI() {
    const keys = new Set(getAvailableMaterialKeys());
    const selectedOptions = document.querySelectorAll('.popover-listbox__option[aria-selected="true"]');
    for (const opt of selectedOptions) {
      const val = opt.getAttribute('value') || opt.textContent || "";
      const key = toKey(val);
      if (keys.has(key)) return val.trim();
    }
    const btns = document.querySelectorAll('button[aria-controls*="popover-variant-picker"]');
    for (const b of btns) {
      const txt = (b.textContent || "").trim();
      const key = toKey(txt);
      if (keys.has(key)) return txt;
    }
    const vis = getVisibleContainer();
    if (vis) {
      const key = vis.getAttribute('data-materiale') || "";
      return key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
    }
    return null;
  }

  function bindSwatchClicks(root = document) {
    root.querySelectorAll(".contenitore-metaobject img").forEach((img) => {
      if (img.dataset.bound === "1") return;
      img.dataset.bound = "1";
      img.addEventListener("click", function () {
        const imgAlt = this.alt || "";
        coloreSelezionato = imgAlt;

        const currentContainer = getVisibleContainer();
        currentContainer?.querySelectorAll("img").forEach(i => {
          i.style.borderRadius = "";
          i.style.marginRight = "";
          i.style.padding = "";
          i.style.outline = "";
        });

        this.style.borderRadius = "10px";
        this.style.marginRight = "0px";
        this.style.padding = "4px";
        this.style.outline = "1px solid #333";

        const selectedColorEl = getSelectedColorEl();
        const hiddenAltInput = getHiddenAltInput();
        if (hiddenAltInput) hiddenAltInput.value = imgAlt;
        setSelectValue(imgAlt);   // il colore scelto compare nel "select"
        hideError();
        // Scelto il colore, richiudo l'accordion: il trigger mostra il colore e si risparmia spazio.
        closeAccordion();
      });
    });
  }

  function gestisciCambioMateriale(materiale) {
    materialeAttivo = materiale;
    const key = toKey(materiale);

    document.querySelectorAll(".contenitore-metaobject").forEach((c) => {
      c.style.display = "none";
      c.querySelectorAll("img").forEach(i => {
        i.style.borderRadius = "";
        i.style.marginRight = "";
        i.style.padding = "";
        i.style.outline = "";
      });
    });

    const cont = document.querySelector(`.contenitore-metaobject[data-materiale="${key}"]`);
    if (cont) cont.style.display = "flex";

    coloreSelezionato = null;
    const hiddenAltInput = getHiddenAltInput();
    const selectedColorEl = getSelectedColorEl();
    if (hiddenAltInput) hiddenAltInput.value = "";
    if (selectedColorEl) selectedColorEl.textContent = ": " + materiale;
    setSelectValue("Seleziona colore");

    const swatches = cont?.querySelectorAll("img") || [];
    if (swatches.length === 0) {
      hideError();
    } else {
      showError(false);
    }
  }

  function preselezionaMaterialePreferito() {
    const samplerEl = getSamplerEl();
    if (!samplerEl) {
      document.querySelectorAll(".variant-picker__option-info").forEach(el => el.style.display = "none");
      return;
    } else {
      document.querySelectorAll(".variant-picker__option-info").forEach(el => el.style.display = "");
    }

    bindSwatchClicks();

    const uiMat = getCurrentMaterialFromUI();
    if (uiMat) {
      gestisciCambioMateriale(uiMat);
      return;
    }
    if (document.querySelector('.contenitore-metaobject[data-materiale="microfibra"]')) {
      gestisciCambioMateriale("Microfibra");
      return;
    }
    const first = document.querySelector('.contenitore-metaobject[data-materiale]');
    if (first) {
      const human = (first.getAttribute("data-materiale") || "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, c => c.toUpperCase());
      gestisciCambioMateriale(human);
    }
  }

  // Listbox materiale
  document.querySelectorAll(".popover-listbox__option").forEach((button) => {
    button.addEventListener("click", function (event) {
      document.querySelectorAll(".popover-listbox__option").forEach((b) => b.setAttribute("aria-selected", "false"));
      event.currentTarget.setAttribute("aria-selected", "true");
      gestisciCambioMateriale(event.currentTarget.getAttribute("value"));
    });
  });

  document.addEventListener("click", function (e) {
    const t = e.target.closest('button[aria-controls*="popover-variant-picker"]');
    if (!t) return;
    setTimeout(preselezionaMaterialePreferito, 0);
  });

  document.addEventListener("click", function (event) {
    const btn = event.target.closest(addToCartSelectors);
    if (!btn) return;
    if (mustBlockAddToCart()) {
      event.preventDefault();
      event.stopPropagation();
      scrollToSampler();   // porta il campionario in vista se serve, senza aprirlo
      showError(false);    // mostra solo il messaggio
    }
  }, true);

  document.addEventListener("submit", function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const isAddToCartForm =
      form.matches('form[action*="/cart/add"]') ||
      form.querySelector('[name="add"]') ||
      form.querySelector('[type="submit"]');

    if (isAddToCartForm && mustBlockAddToCart()) {
      event.preventDefault();
      event.stopPropagation();
      scrollToSampler();
      showError(false);
    }
  }, true);

  preselezionaMaterialePreferito();
  bindAccordionToggle();

  // --- MutationObserver: ripristina solo se non c'è già un colore selezionato ---
  let moTimeout = null;
  const mo = new MutationObserver(() => {
    clearTimeout(moTimeout);
    moTimeout = setTimeout(() => {
      bindSwatchClicks();
      bindAccordionToggle();
      if (!coloreSelezionato) {
        preselezionaMaterialePreferito();
      }
    }, 50);
  });
  mo.observe(document.body, { childList: true, subtree: true, attributes: true });
});



// —————— DESCRIZIONE PRODOTTO: MOSTRA DI PIÙ ——————
document.addEventListener("DOMContentLoaded", function () {
  const COLLAPSED = 200; // altezza visibile da chiuso (px) — unico punto da regolare

  const container = document.querySelector(".product-info__description");
  if (!container) return;
  const prose = container.querySelector(".prose");
  if (!prose) return;

  // Neutralizzo eventuali troncamenti preesistenti (altezza fissa, line-clamp),
  // così l'unico troncamento è il nostro max-height, che è animabile.
  prose.style.height = "auto";
  prose.style.setProperty("-webkit-line-clamp", "unset");
  prose.style.setProperty("-webkit-box-orient", "unset");
  if (getComputedStyle(prose).display === "-webkit-box") prose.style.display = "block";

  const full = prose.scrollHeight;
  if (full <= COLLAPSED + 20) return; // testo già corto: niente troncamento né pulsante

  prose.classList.add("prose--collapsible");
  prose.style.maxHeight = COLLAPSED + "px";

  const button = document.createElement("button");
  button.type = "button";
  button.className = "mostra-di-piu";
  button.textContent = "Mostra di più";
  container.appendChild(button);

  let open = false;

  function expand() {
    prose.style.maxHeight = prose.scrollHeight + "px"; // altezza reale = animazione corretta
    prose.classList.add("is-open");
    button.textContent = "Mostra meno";
    open = true;
  }

  function collapse() {
    // parto dall'altezza reale per poter animare verso il basso
    prose.style.maxHeight = prose.scrollHeight + "px";
    requestAnimationFrame(function () {
      prose.style.maxHeight = COLLAPSED + "px";
    });
    prose.classList.remove("is-open");
    button.textContent = "Mostra di più";
    open = false;
    // in chiusura torno su all'inizio del contenuto, solo se è finito sopra il viewport
    if (container.getBoundingClientRect().top < 0) {
      container.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  // a fine apertura tolgo il vincolo, così immagini/font che caricano dopo non vengono tagliati
  prose.addEventListener("transitionend", function (e) {
    if (e.propertyName === "max-height" && open) prose.style.maxHeight = "none";
  });

  button.addEventListener("click", function () {
    if (open) {
      collapse();
    } else {
      expand();
    }
  });
});



// —————— POPUP BADGE SCONTO ——————
document.addEventListener("DOMContentLoaded", function () {
    var onSaleBadges = document.querySelectorAll(
        "on-sale-badge.badge--on-sale"
    );
    onSaleBadges.forEach(function (onSaleBadge) {
        var infoButton = document.createElement("button");
        infoButton.className = "info-button";
        infoButton.innerText = "i";

        var popup = document.createElement("div");
        popup.id = "popup-sconto";
        popup.className = "popup-sconto";

        var isOccasioni =
            onSaleBadge.getAttribute("data-occasioni") === "true";
        popup.innerHTML = isOccasioni
            ? `<p>Acquistando da Sofable ottieni arredi esclusivi ad un prezzo inferiore del 40% rispetto a prodotti di pari qualità. Per i prodotti in pronta consegna puoi ottenere un risparmio ulteriore.</p>`
            : `<p>Acquistando da Sofable ottieni arredi esclusivi ad un prezzo inferiore del 40% rispetto a prodotti di pari qualità. Questo vantaggio nasce dalla nostra scelta di eliminare definitivamente ogni intermediario.</p>`;

        onSaleBadge.appendChild(infoButton);
        onSaleBadge.appendChild(popup);

        infoButton.addEventListener("click", function () {
            popup.style.display =
                popup.style.display === "block" ? "none" : "block";
        });

        window.addEventListener("click", function (event) {
            if (
                !event.target.matches(".info-button") &&
                !event.target.closest(".popup-sconto")
            ) {
                popup.style.display = "none";
            }
        });
    });
});

// —————— HEADER DINAMICO ——————
document.addEventListener("DOMContentLoaded", function () {
    var header = document.querySelector(".header");
    var menuWrapper = document.querySelector(
        ".header__link-list"
    );

    menuWrapper.addEventListener("mouseenter", function () {
        header.classList.add("is-filled");
    });
    menuWrapper.addEventListener("mouseleave", function () {
        if (!document.querySelector("details[open]")) {
            header.classList.remove("is-filled");
        }
    });

    document.querySelectorAll("details").forEach(function (details) {
        details.addEventListener("toggle", function () {
            header.classList.toggle("is-filled", this.open);
        });
    });
});

// —————— GEOBLOCKER CUSTOM ——————
document.addEventListener("DOMContentLoaded", function () {
    fetch("https://ipapi.co/json/")
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            if (data.country === "IN" || data.country === "PK") {
                var intervalId = setInterval(function () {
                    var chatElement = document.getElementById(
                        "shopify-chat"
                    );
                    if (chatElement) {
                        chatElement.style.setProperty(
                            "display",
                            "none",
                            "important"
                        );
                        chatElement.style.setProperty(
                            "visibility",
                            "hidden",
                            "important"
                        );
                        clearInterval(intervalId);
                    }
                }, 500);
            }
        })
        .catch(function (error) {
            console.error(
                "Errore nel recupero dei dati di geolocalizzazione:",
                error
            );
        });
});

// —————— LANDING PAGE ——————
document.addEventListener("DOMContentLoaded", function () {
  // estraiamo l'URL in minuscolo per semplificare il confronto
  var href = window.location.href.toLowerCase();

  // se contiene "landing-page" da qualunque parte (non serve lo slash all’inizio)
  if (href.includes("landing")) {
    var style = document.createElement("style");
    style.innerHTML = `
      header { display: none !important; }
      #shopify-chat { display: none !important; }
      .product-card__figure a { pointer-events: none; }
    `;
    document.head.appendChild(style);
  }
});


// —————— UTM SU FORM CONTATTO ——————
document.addEventListener("DOMContentLoaded", function () {
    var params = new URLSearchParams(window.location.search);
    [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term",
    ].forEach(function (k) {
        var v = params.get(k);
        if (!v) return;
        var form = document.querySelector("form");
        if (!form) return;
        var input = form.querySelector('input[name="contact[' + k + ']"]');
        if (!input) {
            input = document.createElement("input");
            input.type = "hidden";
            input.name = "contact[" + k + "]";
            form.appendChild(input);
        }
        input.value = v;
    });
});

// —————— INIETTO UTM NEL BODY MESSAGE ——————
document.addEventListener("DOMContentLoaded", function () {
    var textarea = document.querySelector(
        'textarea[name="contact[body]"]'
    );
    if (!textarea) return;
    var form = textarea.closest("form");
    if (!form) return;

    form.addEventListener("submit", function () {
        var params = new URLSearchParams(window.location.search);
        var utmKeys = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_content",
            "utm_term",
        ];
        var extras = [];
        utmKeys.forEach(function (k) {
            var v = params.get(k);
            if (v) extras.push(k + ": " + decodeURIComponent(v));
        });
        if (extras.length) {
            textarea.value += "\n\n— Parametri UTM —\n" + extras.join("\n");
        }
    });
});

// —————— GOOGLE SHEETS INTEGRATION ——————
document.addEventListener("DOMContentLoaded", function () {
    var params = new URLSearchParams(window.location.search);
    [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term",
    ].forEach(function (key) {
        var val = params.get(key);
        if (val) sessionStorage.setItem(key, val);
    });

    var form = document
        .querySelector('textarea[name="contact[body]"]')
        ?.closest("form");
    if (!form) return;

    form.addEventListener("submit", function (e) {
        var fd = new FormData(form);
        var payload = {};
        fd.forEach(function (value, key) {
            var m = key.match(/^contact\[(.+)\]$/);
            if (m) payload[m[1]] = value;
        });
        [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_content",
            "utm_term",
        ].forEach(function (key) {
            payload[key] = sessionStorage.getItem(key) || "";
        });
        payload.pageUrl = window.location.href;
        payload.pagePath = window.location.pathname;

        fetch(
            "https://script.google.com/macros/s/AKfycbyUEiFpyd3qEsrF0acYQTD30-kyyLyr3GTFEdCYI87McGEk3254vQ6QwNodMS0aAJ5Z/exec",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
                mode: "no-cors",
                keepalive: true,
            }
        );
    });
});

///////////////// -----------------------------------------------------------------
//CONNETTORE PUSHOWL
(function() {
  var DEBUG = false;

  var APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbz7RHHVmZzHZsUmGDyEbi9qfEj7fIDxsgc_lKoLYgGJZjckZUot0nmFAUCOakJD8FkE/exec";

  var ACTION_HOST_MAP = { "deb967c6.sibforms.com": "privati" };

  var FORM_TOKEN_MAP = {
    "MUIFAMZXwsVjF3H-4-9VYMvujcdSxtTLjcawqdM7-Q1cEFJpl9AFZC0kBZGmqKsLXfdhVMkIKaC7xIQVH_lUOwm89VJGju2qfcddQGvv-qC7FPG9lHoflTtZVm21y7RSspsphG6MJExXrakJhoeBXUujgx439Ki-Nl_n_dC0PREWDezBRquZi5FZKOC4cip675HyDncHck2Qs6yp": "privati",
    "MUIFACwjGJloHHb8i6Yx27GqxHEtNPW-E1VINWxZN-pLNuQGE1TW3vm3yQ63U3ghEwiauS9I-G4QcRKGhsje265azAGXDcF7DVNURPNawKcA5jlV3P8FqyA6GuvgY06oZi7vXQ2z_E0Cf_zAd4pvTmgw7HcQRD455RiTTGwFJyZEIUOwO4DMjbOuj040pqKCYHFi2KAAZXBKx-H7": "architetti"
  };

  var UTM_KEYS = ["utm_source","utm_medium","utm_campaign","utm_content","utm_term"];

  if (!window.CSS) window.CSS = {};
  if (!window.CSS.escape) {
    window.CSS.escape = function(s){ return (s+"").replace(/[^a-zA-Z0-9_\-]/g, "\\$&"); };
  }

  function collectUtmsFromUrl(){
    var out = {};
    var p = new URLSearchParams(location.search);
    UTM_KEYS.forEach(function(k){
      var v = p.get(k);
      if (v) out[k] = v;
    });
    return out;
  }

  function getLeadType(form){
    var attr = form.getAttribute("data-lead-type") ||
               (form.closest('[data-lead-type]') && form.closest('[data-lead-type]').getAttribute('data-lead-type'));
    if (attr) return String(attr).toLowerCase();
    try {
      var act = form.getAttribute('action') || '';
      var m = act.match(/serve\/([^/?#]+)/);
      if (m && FORM_TOKEN_MAP[m[1]]) return FORM_TOKEN_MAP[m[1]];
    } catch(_){}
    try {
      var host = new URL(form.action).host;
      if (ACTION_HOST_MAP[host]) return ACTION_HOST_MAP[host];
    } catch(_){}
    return "";
  }

  function pick(form, key){
    if(!key) return '';
    var sel = '[name="'+CSS.escape(key)+'"], #'+CSS.escape(key);
    var el = form.querySelector(sel) || form.querySelector(sel.toLowerCase());
    return el ? (el.value || '').trim() : '';
  }

  function pickByContains(form, what){
    what = what.toLowerCase();
    var fields = form.querySelectorAll('input,textarea,select');
    for (var i=0;i<fields.length;i++){
      var f = fields[i];
      var n = (f.name||'').toLowerCase();
      var id= (f.id||'').toLowerCase();
      var ph = (f.placeholder||'').toLowerCase();
      if (n.includes(what) || id.includes(what) || ph.includes(what)) {
        return (f.value || '').trim();
      }
    }
    return '';
  }

  function formIsLikelyValid(form){
    try { return form.checkValidity(); } catch(_) { return true; }
  }

  function extractBrevoFormToken(form){
    var act = form.getAttribute('action') || '';
    var m = act.match(/serve\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  var lastSentByKey = {};
  function shouldSend(key){
    var now = Date.now();
    if (lastSentByKey[key] && (now - lastSentByKey[key] < 3000)) return false;
    lastSentByKey[key] = now;
    return true;
  }

  function send(payload){
    payload.pageUrl   = location.href;
    payload.pagePath  = location.pathname;
    payload.userAgent = navigator.userAgent || '';
    if (DEBUG) console.log("[SEND] payload", payload);

    try{
      var beaconBlob = new Blob([JSON.stringify(payload)], { type: "text/plain;charset=UTF-8" });
      if (navigator.sendBeacon && navigator.sendBeacon(APPS_SCRIPT_URL, beaconBlob)) return;
    }catch(e){ if(DEBUG) console.warn("sendBeacon error", e); }

    fetch(APPS_SCRIPT_URL, {
      method:"POST",
      headers:{ "Content-Type":"text/plain;charset=UTF-8" },
      body: JSON.stringify(payload),
      mode:"no-cors",
      keepalive:true,
      credentials:"omit",
      cache:"no-store"
    }).catch(function(err){ if(DEBUG) console.warn("fetch error", err); });
  }

  function buildPayload(form){
    var leadType = getLeadType(form);
    var email     = pick(form, "EMAIL")      || pickByContains(form, "email");
    var firstName = pick(form, "NOME")       || pickByContains(form, "nome");
    var lastName  = pick(form, "COGNOME")    || pickByContains(form, "cognome");

    var city = pick(form, "LOCALITA") ||
               pickByContains(form, "citt") ||
               pickByContains(form, "localita") || '';

    var cc   = pick(form, "SMS__COUNTRY_CODE");
    var num  = pick(form, "SMS");
    var phone = num ? (cc ? (cc + " " + num) : num).trim()
                    : (pickByContains(form, "telefono") || pickByContains(form, "phone") || pickByContains(form, "whatsapp") || '');

    var company = pickByContains(form, "azienda") || pickByContains(form, "studio") || pickByContains(form, "ragione") || '';

    var utms = collectUtmsFromUrl();

    var rawFields = {
      EMAIL: email || '',
      NOME: firstName || '',
      COGNOME: lastName || '',
      LOCALITA: city || '',
      AZIENDA: company || '',
      SMS__COUNTRY_CODE: cc || '',
      SMS: num || ''
    };

    var payload = {
      leadType: leadType,
      formId: extractBrevoFormToken(form) || '',
      email: email || '',
      firstName: firstName || '',
      lastName: lastName || '',
      city: city || '',
      phone: phone || '',
      company: company || '',
      consentEmail: !!(form.querySelector('#OPT_IN, [name="OPT_IN"]') && form.querySelector('#OPT_IN, [name="OPT_IN"]').checked),
      rawFields: rawFields
    };

    Object.keys(utms).forEach(function(k){ payload[k] = utms[k]; });
    return payload;
  }

  function handleSubmit(form){
    try{
      if (!formIsLikelyValid(form)) { if(DEBUG) console.log("[SKIP] form non valido"); return; }
      var payload = buildPayload(form);
      var dedupKey = (payload.formId || 'na') + '|' + (payload.email || '');
      if (!shouldSend(dedupKey)) { if(DEBUG) console.log("[DEDUP] skip"); return; }
      if (DEBUG) console.log("[HANDLE]", payload);
      send(payload);
    }catch(e){
      if (DEBUG) console.error("handleSubmit error", e);
    }
  }

  document.addEventListener('submit', function(e){
    var t = e.target;
    if (t && t.matches && (t.matches('#sib-form') || t.matches('form[action*="sibforms.com"]'))) {
      if (DEBUG) console.log("[EVENT] submit sib-form");
      handleSubmit(t);
    }
  }, true);

  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest
      ? e.target.closest('#sib-form button[type="submit"], #sib-form [type="submit"], #sib-form .sib-form-block__button')
      : null;
    if (btn) {
      var form = btn.closest('#sib-form') || document.getElementById('sib-form');
      if (form) {
        if (DEBUG) console.log("[EVENT] click submit sib-form");
        handleSubmit(form);
      }
    }
  }, true);
})();



/////////// CHAT AGENT ACTIVATOR 4S ////////////

(function () {
  const DELAY = 8000;
  const ONCE_KEY = 'sofable_chat_autoopen';

  if (sessionStorage.getItem(ONCE_KEY)) return;
  if (window.matchMedia('(max-width: 749px)').matches) return;
  // rispetta chi ha già chiuso il widget in passato
  if (localStorage.getItem('sofable_chat_dismissed')) return;

  function getActivator() {
    const host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector(
      'button.activator, button[part="activator"]'
    );
  }

  function tryOpen(attempt = 0) {
    const btn = getActivator();
    if (btn) {
      // apri solo se è chiusa
      if (btn.getAttribute('aria-expanded') === 'false') btn.click();
      sessionStorage.setItem(ONCE_KEY, '1');
      trackDismiss(btn);
      return;
    }
    if (attempt < 20) setTimeout(() => tryOpen(attempt + 1), 500);
  }

  // se l'utente la chiude, non riproporla più
  function trackDismiss(btn) {
    new MutationObserver(() => {
      if (btn.getAttribute('aria-expanded') === 'false') {
        localStorage.setItem('sofable_chat_dismissed', '1');
      }
    }).observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
  }

  window.addEventListener('load', () => setTimeout(tryOpen, DELAY));
})();